// src/hooks/useStepValidation.ts
import { useMemo } from "react";
import { CardCustomization } from "../types/card.types";
import { StepValidation } from "../types/studio.types";

export const useStepValidation = (
  customization: CardCustomization | null,
): StepValidation => {
  return useMemo(() => {
    if (!customization) {
      return {
        isStep1Valid: false,
        isStep2Valid: false,
        isStep3Valid: false,
        isStep4Valid: true,
      };
    }

    const isStep1Valid = Boolean(
      customization.recipientName?.trim() && customization.senderName?.trim(),
    );

    const isStep2Valid = Boolean(customization.message?.trim().length >= 10);

    const isStep3Valid = Boolean(customization.recipientImage);

    const isStep4Valid = true;

    return {
      isStep1Valid,
      isStep2Valid,
      isStep3Valid,
      isStep4Valid,
    };
  }, [customization]);
};
